import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { useLanguage } from "../contexts/LanguageContext";
import { T } from "../i18n/strings";
import { ArticleCard } from "../components/ArticleCard";

export default function Section() {
  const { slug } = useParams();
  const { lang } = useLanguage();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/articles", { params: { section: slug, limit: 60 } })
      .then((r) => setArticles(r.data))
      .finally(() => setLoading(false));
  }, [slug]);

  const label = T.nav[slug]?.[lang] || slug;
  const [lead, ...rest] = articles;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14" data-testid={`section-page-${slug}`}>
      <div className="mb-10 border-b border-[#081422]/15 pb-6">
        <div className="pw-eyebrow">{T.labels.section[lang]}</div>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-bold text-[#081422] tracking-tight mt-2">
          {label}
        </h1>
      </div>

      {loading ? (
        <p className="font-mono-meta text-xs uppercase tracking-widest text-[#64748B]" data-testid="loading">Loading...</p>
      ) : articles.length === 0 ? (
        <p className="font-serif-body text-lg text-[#475569]" data-testid="empty">{T.labels.noResults[lang]}</p>
      ) : (
        <>
          {lead && (
            <div className="mb-14">
              <ArticleCard article={lead} variant="lead" />
            </div>
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {rest.map((a) => <ArticleCard key={a.id} article={a} />)}
          </div>
        </>
      )}
    </div>
  );
}
